<template>
  <inline-svg :src="getPatientGenderIconPath()"></inline-svg>
</template>

<script>
export default {
  props: {
    gender: {
      type: String,
      required: true
    }
  },
  methods: {
    getPatientGenderIconPath() {
      const genders = ['female', 'male', 'non_binary', 'prefer_not_specify', 'other'];
      const icon = genders.find(g => g === this.gender.toLowerCase()) || 'other';
      // eslint-disable-next-line global-require, import/no-dynamic-require
      return require(`@ui-kit/assets/images/gender/gender-icons/${icon}.svg`);
    },
  },
};
</script>
